import * as MD from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';
import MuiTextField from '@material-ui/core/TextField';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab/';
import * as React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N } from '../../Store/I18n/Types';
import { IUserState } from '../../Store/User/Types';
import Alert from '@material-ui/lab/Alert';
// import CloseIcon from '@material-ui/icons/Close';

import {
	getACLParents,
	getACLUserByID,
	modifyACLUserDateDebut,
	modifyACLUserDateExpire,
	modifyACLUserEmail,
	modifyACLUserFirstname,
	modifyACLUserIsActive,
	modifyACLUserLanguage,
	modifyACLUserLocalisation,
	modifyACLUserName,
	modifyACLUserParent,
	modifyACLUserPhone,
	modifyACLUserPosition,
	modifyACLUserUsername,
	updateACLUserModifiedName,
	updateACLUserModifiedFirstname,
	updateACLUserModifiedUsername,
	updateACLUserModifiedEmail,
	updateACLUserModifiedParent,
	updateACLUserModifiedPhoneNumber,
	updateACLUserModifiedPosition,
	updateACLUserModifiedLocalisation,
	updateACLUserModifiedLanguage,
	updateACLUserModifiedStartDate,
	updateACLUserModifiedEndDate,
	updateACLUserModifiedUserActive,
} from '../../Store/UserManagement/Actions';
import { IUserManagementState, Parent } from '../../Store/UserManagement/Types';
import { getTheme } from '../../Themes';
import { YacastLogoIcon } from '../../Themes/svg/yacast-logo';
import {
	isNullOrUndefined,
	isNullOrUndefinedOrEmptyString,
} from '../../Utils/Various';
import { countriesFiltered, languages } from './UserManagementGlobal';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	userManagement: IUserManagementState;
}

interface IPropsFromDispatch {
	getACLParents: typeof getACLParents;
	getACLUserByID: typeof getACLUserByID;
	modifyACLUserDateDebut: typeof modifyACLUserDateDebut;
	modifyACLUserDateExpire: typeof modifyACLUserDateExpire;
	modifyACLUserEmail: typeof modifyACLUserEmail;
	modifyACLUserFirstname: typeof modifyACLUserFirstname;
	modifyACLUserIsActive: typeof modifyACLUserIsActive;
	modifyACLUserLanguage: typeof modifyACLUserLanguage;
	modifyACLUserName: typeof modifyACLUserName;
	modifyACLUserParent: typeof modifyACLUserParent;
	modifyACLUserPhone: typeof modifyACLUserPhone;
	modifyACLUserUsername: typeof modifyACLUserUsername;
	modifyACLUserLocalisation: typeof modifyACLUserLocalisation;
	modifyACLUserPosition: typeof modifyACLUserPosition;
	updateACLUserModifiedName: typeof updateACLUserModifiedName;
	updateACLUserModifiedFirstname: typeof updateACLUserModifiedFirstname;
	updateACLUserModifiedUsername: typeof updateACLUserModifiedUsername;
	updateACLUserModifiedEmail: typeof updateACLUserModifiedEmail;
	updateACLUserModifiedParent: typeof updateACLUserModifiedParent;
	updateACLUserModifiedPhoneNumber: typeof updateACLUserModifiedPhoneNumber;
	updateACLUserModifiedPosition: typeof updateACLUserModifiedPosition;
	updateACLUserModifiedLocalisation: typeof updateACLUserModifiedLocalisation;
	updateACLUserModifiedLanguage: typeof updateACLUserModifiedLanguage;
	updateACLUserModifiedStartDate: typeof updateACLUserModifiedStartDate;
	updateACLUserModifiedEndDate: typeof updateACLUserModifiedEndDate;
	updateACLUserModifiedUserActive: typeof updateACLUserModifiedUserActive;
}

interface IState {
	errorModification: boolean;
	errorModificationMsg: string;
	isActiveModified: boolean;
	errorEndDate: boolean;
	errorStartDate: boolean;
	openAlert: boolean;
}

const initialState: IState = {
	errorModification: false,
	errorModificationMsg: '',
	isActiveModified: false,
	errorEndDate: false,
	errorStartDate: false,
	openAlert: false,
};

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

const theme = getTheme();

const styles = MD.createStyles({
	button: {
		margin: theme.spacing(1),
		marginLeft: 0,
		marginRight: 0,
		textTransform: 'uppercase',
	},
	card: {
		maxWidth: '55%',
		minWidth: '20%',
		margin: 'auto',
		marginTop: '3%',
	},
	cardContent: {
		width: '100%',
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
	},
	label: {
		paddingTop: '15px',
	},
	filling: {
		color: '#000000',
	},
});

const DensedTextField = styled(MuiTextField)`
	.MuiInputBase-input {
		padding: 4px 6px;
		font-size: 13px;
	}
	.MuiInputLabel-formControl {
		top: -7px;
		font-size: 13px;
		font-weight: 300;
	}
`;

export class UserManagementModificationComponent extends React.Component<
	AllProps,
	IState
> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			...initialState,
		};
	}

	public componentDidMount() {
		if (
			this.props.router.match.params.groupName !== undefined &&
			!isNaN(parseInt(this.props.router.match.params.groupName, 10))
		) {
			this.props.getACLUserByID(
				this.props.user.token,
				parseInt(this.props.router.match.params.groupName, 10)
			);
		}
	}

	public render(): React.ReactNode {
		if (
			this.props.router.match.params.groupName !== undefined &&
			!isNaN(parseInt(this.props.router.match.params.groupName, 10))
		) {
			return (
				<React.Fragment>
					{this.props.userManagement.ACLUserLoading ? (
						<div style={{ paddingTop: 30 }}>
							{this.props.i18n._('Loading')}...
						</div>
					) : (
						this.showModificationCard()
					)}
				</React.Fragment>
			);
		} else {
			return <React.Fragment>{this.selectUserID()}</React.Fragment>;
		}
	}
	private selectUserID(): React.ReactNode {
		return (
			<p>
				{this.props.i18n._(
					'Please select an user before checking the rights attributed'
				)}
			</p>
		);
	}

	private showModificationCard(): React.ReactNode {
		const { classes } = this.props;
		return (
			<MD.Card className={classes.card}>
				<MD.CardActionArea></MD.CardActionArea>
				<MD.CardActions>
					<MD.CardContent className={classes.cardContent}>
						<MD.Typography
							gutterBottom={true}
							variant="h4"
							component="h2"
						>
							<SvgIcon
								component={YacastLogoIcon}
								htmlColor={theme.palette.text.primary}
							/>
						</MD.Typography>

						<MD.Typography
							variant="caption"
							color="textSecondary"
							component="p"
						></MD.Typography>
						{this.props.userManagement.isModificationSucceed ? (
							<p>
								{this.props.i18n._(
									"l'utilisateur a été modifié"
								)}
							</p>
						) : (
							''
						)}
						{this.getForm()}
						{this.showAlert()}
					</MD.CardContent>
				</MD.CardActions>
			</MD.Card>
		);
	}

	private showAlert() {
		return (
			<MD.Snackbar
				open={this.state.openAlert}
				autoHideDuration={3000}
				onClose={() => {
					this.setState({ openAlert: false });
				}}
			>
				<Alert
					severity="success"
					onClose={() => this.setState({ openAlert: false })}
				>
					{this.props.i18n._('User updated')}
				</Alert>
			</MD.Snackbar>
		);
	}

	private getForm(): React.ReactNode {
		const { classes } = this.props;
		return (
			<form
				className={classes.form}
				noValidate={true}
				onSubmit={this.onSubmit.bind(this)}
			>
				<MD.InputLabel className={classes.label}>ID</MD.InputLabel>
				<DensedTextField
					disabled
					margin="normal"
					value={this.props.userManagement.userToModify.id}
				/>
				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('Name')}
				</MD.InputLabel>
				<DensedTextField
					margin="normal"
					value={this.props.userManagement.userModified.name}
					onChange={(event: any) => {
						this.props.updateACLUserModifiedName(
							event.target.value as string
						);
					}}
				/>
				{this.props.userManagement.userToModify.isgroup ? (
					''
				) : (
					<React.Fragment>
						<MD.InputLabel className={classes.label}>
							{this.props.i18n._('Firstname')}
						</MD.InputLabel>
						<DensedTextField
							margin="normal"
							value={
								this.props.userManagement.userModified.firstname
							}
							onChange={(event: any) => {
								this.props.updateACLUserModifiedFirstname(
									event.target.value as string
								);
							}}
						/>
					</React.Fragment>
				)}
				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('Username')}
				</MD.InputLabel>
				<DensedTextField
					margin="normal"
					value={this.props.userManagement.userModified.username}
					onChange={(event: any) => {
						this.props.updateACLUserModifiedUsername(
							event.target.value as string
						);
					}}
				/>
				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('Email')}
				</MD.InputLabel>
				<DensedTextField
					margin="normal"
					value={this.props.userManagement.userModified.email}
					onChange={(event: any) => {
						this.props.updateACLUserModifiedEmail(
							event.target.value as string
						);
					}}
				/>
				{this.props.userManagement.userToModify.isgroup ? (
					''
				) : this.props.user.groupID === 2 ? (
					<React.Fragment>
						<MD.InputLabel className={classes.label}>
							{this.props.i18n._('Parent')}
						</MD.InputLabel>
						<Autocomplete
							options={this.props.userManagement.parentsACLData}
							onChange={(ev: React.ChangeEvent<{}>, val: any) => {
								if (
									!isNullOrUndefined(val) &&
									!isNullOrUndefinedOrEmptyString(val.name)
								) {
									let parent: Parent = {
										id: val.id,
										name: val.name,
										username: val.username,
										email: val.email,
										isactive: val.isactive,
										isgroup: val.isgroup,
									};
									this.props.updateACLUserModifiedParent(
										parent
									);
								}
							}}
							getOptionLabel={(option) => option.name || option.username}
							renderInput={(
								params: AutocompleteRenderInputParams
							) => (
								<MD.TextField
									{...params}
									label={
										'Previous Parent: ' +
										this.props.userManagement.userToModify
											.parent.name
									}
									value={
										this.props.userManagement.userModified
											.parent.name
									}
									onChange={(event: any) => {
										this.props.getACLParents(
											this.props.user.token,
											event.target.value
										);
									}}
								/>
							)}
						/>
						<MD.InputLabel className={classes.label}>
							{this.props.i18n._('Phone number')}
						</MD.InputLabel>
						<DensedTextField
							disabled
							margin="normal"
							label={this.props.i18n._('Previous phone number')}
							value={
								'+ ' +
								this.props.userManagement.userToModify.phone
							}
							InputLabelProps={{
								shrink: true,
							}}
						/>
						<PhoneInput
							specialLabel=""
							containerStyle={{
								color: '#C4C4C4',
								padding: '5px 5px',
								fontSize: '13px',
							}}
							inputStyle={{
								color: '#C4C4C4',
								width: '100%',
								padding: '5px 5px 5px 58px',
								backgroundColor: 'transparent',
							}}
							buttonStyle={{}}
							dropdownStyle={{
								backgroundColor: '#35394B',
								width: 'max-content',
							}}
							searchStyle={{ backgroundColor: '#C54CFB' }}
							country={'fr'}
							regions={'europe'}
							value={this.props.userManagement.userModified.phone}
							onChange={(value: string, event: any) => {
								this.props.updateACLUserModifiedPhoneNumber(
									value
								);
							}}
						/>
						<MD.InputLabel className={classes.label}>
							{this.props.i18n._('Position')}
						</MD.InputLabel>
						<DensedTextField
							margin="normal"
							value={
								this.props.userManagement.userModified.position
							}
							onChange={(event: any) => {
								this.props.updateACLUserModifiedPosition(
									event.target.value as string
								);
							}}
						/>
						<MD.InputLabel className={classes.label}>
							{this.props.i18n._('Localisation')}
						</MD.InputLabel>
						<MD.Select
							multiple
							value={
								this.props.userManagement.userModified
									.localisation
							}
							onChange={(
								event: React.ChangeEvent<{ value: unknown }>
							) => {
								this.props.updateACLUserModifiedLocalisation(
									event.target.value as string[]
								);
							}}
							input={<MD.Input />}
							renderValue={(selected) =>
								(selected as string[]).join(', ')
							}
						>
							{countriesFiltered.map((country) => (
								<MD.MenuItem
									key={country.code}
									value={country.code}
								>
									<MD.Checkbox
										checked={
											this.props.userManagement.userModified.localisation.indexOf(
												country.code
											) > -1
										}
									/>
									<MD.ListItemText primary={country.label} />
								</MD.MenuItem>
							))}
						</MD.Select>
						<MD.InputLabel className={classes.label}>
							{this.props.i18n._('Language')}
						</MD.InputLabel>
						<MD.Select
							value={
								this.props.userManagement.userModified.language
							}
							onChange={(
								event: React.ChangeEvent<{ value: unknown }>
							) => {
								this.props.updateACLUserModifiedLanguage(
									event.target.value as string
								);
							}}
							input={<MD.Input />}
							renderValue={(selected) => selected as string}
						>
							{languages.map((language) => (
								<MD.MenuItem
									key={language.code}
									value={language.label}
								>
									<MD.ListItemText primary={language.label} />
								</MD.MenuItem>
							))}
						</MD.Select>
					</React.Fragment>
				) : (
					''
				)}

				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('Creation date')}
				</MD.InputLabel>
				<DensedTextField
					disabled
					margin="normal"
					value={this.props.userManagement.userToModify.date_creation}
					InputLabelProps={{
						shrink: true,
					}}
				/>

				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('Start date')}
				</MD.InputLabel>
				<DensedTextField
					helperText={
						'Format: jj/mm/aaaa HH:MM or jj/mm/aaaa HH:MM:SS'
					}
					error={this.state.errorStartDate}
					margin="normal"
					placeholder={this.props.i18n._('Start date')}
					value={
						this.props.userManagement.userModified.date_debut === ''
							? this.props.userManagement.userToModify
									.date_debut === undefined
								? ''
								: this.props.userManagement.userToModify.date_debut.replace(
										' ',
										'T'
								  )
							: this.props.userManagement.userModified.date_debut
					}
					InputLabelProps={{
						shrink: true,
					}}
					onChange={(event: any) => {
						let onError = false;

						if (event.target.value !== '') {
							const re =
								/^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d\d\d\d (20|21|22|23|[0-1]?\d):[0-5]?\d(:[0-5]?\d)?$/;
							onError = !re.test(event.target.value);
						}

						this.props.updateACLUserModifiedStartDate(
							event.target.value as string
						);

						this.setState({
							...this.state,
							errorStartDate: onError,
						});
					}}
				/>
				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('End date')}
				</MD.InputLabel>
				<DensedTextField
					helperText={
						'Format: jj/mm/aaaa HH:MM or jj/mm/aaaa HH:MM:SS'
					}
					error={this.state.errorEndDate}
					InputLabelProps={{
						shrink: true,
					}}
					onChange={(event: any) => {
						let onError = false;

						if (event.target.value !== '') {
							const re =
								/^([1-9]|([012][0-9])|(3[01]))\/([0]{0,1}[1-9]|1[012])\/\d\d\d\d (20|21|22|23|[0-1]?\d):[0-5]?\d(:[0-5]?\d)?$/;
							onError = !re.test(event.target.value);
						}

						this.props.updateACLUserModifiedEndDate(
							event.target.value as string
						);

						this.setState({
							...this.state,
							errorEndDate: onError,
						});
					}}
					margin="normal"
					placeholder={this.props.i18n._('Never')}
					value={
						this.props.userManagement.userModified.date_expire ===
						''
							? this.props.userManagement.userToModify
									.date_expire === undefined
								? ''
								: this.props.userManagement.userToModify.date_expire.replace(
										' ',
										'T'
								  )
							: this.props.userManagement.userModified.date_expire
					}
				/>
				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('User active')}
				</MD.InputLabel>
				<MD.FormControlLabel
					control={
						<MD.Switch
							checked={
								this.props.userManagement.userModified.isactive
							}
							onChange={(
								event: React.ChangeEvent<HTMLInputElement>
							) => {
								this.props.updateACLUserModifiedUserActive(
									!this.props.userManagement.userModified
										.isactive
								);
							}}
							name="isActive"
						/>
					}
					label={this.props.i18n._('Active')}
				/>

				<MD.Button
					className={classes.button}
					color="primary"
					variant="contained"
					onClick={this.onSubmit.bind(this)}
				>
					{this.props.i18n._('Update')}
				</MD.Button>
			</form>
		);
	}

	private onSubmit() {
		if (
			this.props.userManagement.userModified.name !==
				this.props.userManagement.userToModify.name &&
			this.props.userManagement.userModified.name.length !== 0
		) {
			this.props.modifyACLUserName(
				this.props.user.token,
				this.props.userManagement.userToModify.id,
				this.props.userManagement.userModified.name
			);
		}
		if (
			this.props.userManagement.userModified.firstname !==
				this.props.userManagement.userToModify.firstname &&
			this.props.userManagement.userModified.firstname.length !== 0
		) {
			this.props.modifyACLUserFirstname(
				this.props.user.token,
				this.props.userManagement.userToModify.id,
				this.props.userManagement.userModified.firstname
			);
		}
		if (
			this.props.userManagement.userModified.username !==
				this.props.userManagement.userToModify.username &&
			this.props.userManagement.userModified.username.length !== 0
		) {
			this.props.modifyACLUserUsername(
				this.props.user.token,
				this.props.userManagement.userToModify.id,
				this.props.userManagement.userModified.username
			);
		}
		if (
			this.props.userManagement.userModified.email !==
				this.props.userManagement.userToModify.email &&
			this.props.userManagement.userModified.email.length !== 0
		) {
			this.props.modifyACLUserEmail(
				this.props.user.token,
				this.props.userManagement.userToModify.id,
				this.props.userManagement.userModified.email
			);
		}
		if (
			this.props.userManagement.userModified.date_debut !==
				this.props.userManagement.userToModify.date_debut &&
			this.props.userManagement.userModified.date_debut.length !== 0
		) {
			this.props.userManagement.userModified.date_debut.replace('T', ' ')
				.length === 19
				? this.props.modifyACLUserDateDebut(
						this.props.user.token,
						this.props.userManagement.userToModify.id,
						this.props.userManagement.userModified.date_debut.replace(
							'T',
							' '
						)
				  )
				: this.props.modifyACLUserDateDebut(
						this.props.user.token,
						this.props.userManagement.userToModify.id,
						this.props.userManagement.userModified.date_debut.replace(
							'T',
							' '
						) + ':00'
				  );
		}
		if (
			this.props.userManagement.userModified.date_expire !==
				this.props.userManagement.userToModify.date_expire &&
			this.props.userManagement.userModified.date_expire.length !== 0
		) {
			this.props.userManagement.userModified.date_expire.replace('T', ' ')
				.length === 19
				? this.props.modifyACLUserDateExpire(
						this.props.user.token,
						this.props.userManagement.userToModify.id,
						this.props.userManagement.userModified.date_expire.replace(
							'T',
							' '
						)
				  )
				: this.props.modifyACLUserDateExpire(
						this.props.user.token,
						this.props.userManagement.userToModify.id,
						this.props.userManagement.userModified.date_expire.replace(
							'T',
							' '
						) + ':00'
				  );
		}
		if (
			this.props.userManagement.userModified.parent.id !==
				this.props.userManagement.userToModify.parent.id &&
			this.props.userManagement.userModified.parent.id > 0
		) {
			this.props.modifyACLUserParent(
				this.props.user.token,
				this.props.userManagement.userToModify.id,
				this.props.userManagement.userModified.parent.id
			);
		}
		if (
			this.props.userManagement.userModified.isactive !==
			this.props.userManagement.userToModify.isactive
		) {
			this.props.modifyACLUserIsActive(
				this.props.user.token,
				this.props.userManagement.userToModify.id,
				this.props.userManagement.userModified.isactive
			);
		}
		if (this.props.userManagement.userModified.phone !== undefined) {
			if (
				this.props.userManagement.userModified.phone.length > 10 &&
				this.props.userManagement.userModified.phone !==
					this.props.userManagement.userToModify.phone
			) {
				this.props.modifyACLUserPhone(
					this.props.user.token,
					this.props.userManagement.userToModify.id,
					this.props.userManagement.userModified.phone
				);
			}
		}
		if (
			this.props.userManagement.userModified.language !== '' &&
			this.props.userManagement.userModified.language !==
				this.props.userManagement.userToModify.language
		) {
			this.props.modifyACLUserLanguage(
				this.props.user.token,
				this.props.userManagement.userToModify.id,
				this.props.userManagement.userModified.language
			);
		}
		if (
			this.props.userManagement.userModified.localisation !==
			this.props.userManagement.userToModify.localisation
		) {
			this.props.modifyACLUserLocalisation(
				this.props.user.token,
				this.props.userManagement.userToModify.id,
				this.props.userManagement.userModified.localisation
			);
		}
		if (this.props.userManagement.userModified.position !== undefined) {
			if (
				this.props.userManagement.userModified.position !== '' &&
				this.props.userManagement.userModified.position !==
					this.props.userManagement.userToModify.position
			) {
				this.props.modifyACLUserPosition(
					this.props.user.token,
					this.props.userManagement.userToModify.id,
					this.props.userManagement.userModified.position
				);
			}
		}
		this.setState({ openAlert: true });
	}
}

const mapStateToProps = (
	{ i18n, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLParents: (token: string, researchField: string) =>
		dispatch(getACLParents(token, researchField)),
	getACLUserByID: (token: string, params: number) =>
		dispatch(getACLUserByID(token, params)),
	modifyACLUserDateDebut: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserDateDebut(token, id, param)),
	modifyACLUserDateExpire: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserDateExpire(token, id, param)),
	modifyACLUserEmail: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserEmail(token, id, param)),
	modifyACLUserFirstname: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserFirstname(token, id, param)),
	modifyACLUserIsActive: (token: string, id: number, param: boolean) =>
		dispatch(modifyACLUserIsActive(token, id, param)),
	modifyACLUserLanguage: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserLanguage(token, id, param)),
	modifyACLUserLocalisation: (token: string, id: number, param: string[]) =>
		dispatch(modifyACLUserLocalisation(token, id, param)),
	modifyACLUserName: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserName(token, id, param)),
	modifyACLUserParent: (token: string, id: number, param: number) =>
		dispatch(modifyACLUserParent(token, id, param)),
	modifyACLUserPosition: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserPosition(token, id, param)),
	modifyACLUserPhone: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserPhone(token, id, param)),
	modifyACLUserUsername: (token: string, id: number, param: string) =>
		dispatch(modifyACLUserUsername(token, id, param)),
	updateACLUserModifiedName: (data: string) =>
		dispatch(updateACLUserModifiedName(data)),
	updateACLUserModifiedFirstname: (data: string) =>
		dispatch(updateACLUserModifiedFirstname(data)),
	updateACLUserModifiedUsername: (data: string) =>
		dispatch(updateACLUserModifiedUsername(data)),
	updateACLUserModifiedEmail: (data: string) =>
		dispatch(updateACLUserModifiedEmail(data)),
	updateACLUserModifiedParent: (data: Parent) =>
		dispatch(updateACLUserModifiedParent(data)),
	updateACLUserModifiedPhoneNumber: (data: string) =>
		dispatch(updateACLUserModifiedPhoneNumber(data)),
	updateACLUserModifiedPosition: (data: string) =>
		dispatch(updateACLUserModifiedPosition(data)),
	updateACLUserModifiedLocalisation: (data: string[]) =>
		dispatch(updateACLUserModifiedLocalisation(data)),
	updateACLUserModifiedLanguage: (data: string) =>
		dispatch(updateACLUserModifiedLanguage(data)),
	updateACLUserModifiedStartDate: (data: string) =>
		dispatch(updateACLUserModifiedStartDate(data)),
	updateACLUserModifiedEndDate: (data: string) =>
		dispatch(updateACLUserModifiedEndDate(data)),
	updateACLUserModifiedUserActive: (data: boolean) =>
		dispatch(updateACLUserModifiedUserActive(data)),
});

export const UserManagementModification = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(UserManagementModificationComponent));
